/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
const ENVs = {
  GoogleMapsApiKey: function () {
    if (process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
      return process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    }
    if (window.frontendENV.MAPS_API_KEY) {
      return window.frontendENV.MAPS_API_KEY;
    }
  },
  AboutHTML: function () {
    if (window.frontendENV?.ABOUT) {
      return window.frontendENV.ABOUT;
    } else {
      return '<p>You can specify this in appsettings.json</p>';
    }
  },
  PolicyHTML: function () {
    if (window.frontendENV?.POLICY) {
      return window.frontendENV.POLICY;
    } else {
      return '<p>You can specify this in appsettings.json</p>';
    }
  },
  Images: function () {
    if (window.frontendENV?.Images) {
      return window.frontendENV.Images;
    }
  },
  JobManagement: function () {
    if (window.frontendENV?.JobManagement) {
      return window.frontendENV.JobManagement;
    }
  },
  MqttUsername: function () {
    if (window.frontendENV?.MQTT_USERNAME) {
      return window.frontendENV?.MQTT_USERNAME;
    }
    // might be undefined intentionally
  },
  MqttPassword: function () {
    if (window.frontendENV?.MQTT_PASSWORD) {
      return window.frontendENV?.MQTT_PASSWORD;
    }
    // might be undefined intentionally
  },

  /**
   * @param {boolean} avail
   * @returns {string}
   */
  WatermarkedBucketUrl: function (avail) {
    if (window.frontendENV?.WATERMARKED_BUCKET && avail) {
      return window.frontendENV?.WATERMARKED_BUCKET;
    } else {
      return '';
    }
  },

  /**
   * @param {boolean} avail
   * @returns {string}
   */
  StaticBucketUrl: function (avail) {
    if (window.frontendENV?.STATIC_BUCKET && avail) {
      return window.frontendENV?.STATIC_BUCKET;
    } else {
      return '';
    }
  },
};

export default ENVs;
